module.exports = __webpack_public_path__ + "img/imagepreview.83db48e3.svg";